import { addResourceBundles } from './i18n-util';

export const loadResourceBundles = (i18n, locale = 'es-MX') => {
	return getLang(locale)
		.then((module) => {
			const langFiles = module.default;
			addResourceBundles(i18n, locale, langFiles);
		});
};

export const getLang = (locale) => {
	switch (locale) {
		case 'es-MX':
			return import('./es-MX');
	}
};



// WEBPACK FOOTER //
// ./client/i18n/i18n.js